export default "__VITE_ASSET__BbU4R_UZ__"